import React,{useState} from "react";
import { Col, Row } from "reactstrap";
import "../CSS/Grids.css";
export default function Grids(props) {  
  const data = Array.from({ length: 6 }, () => Array.from({ length: 6 }, () => " "));
 
  const highlightedCell = Array.from(props.highlightedCells || []);
  const highlightedCells = highlightedCell.map((grid) => ({
    row: grid.row,
    col: grid.column,
  }));
  return (
    <div  
    style={{height:"100%", width:"100%", objectFit:"contain", zIndex:-1}}
    //className="resized_table"
    >
      {/* <tbody> */}
        {data.map((row, rowIndex) => (
          <Row
            key={rowIndex}
           className="row_height"  
           
          >
            {row.map((cell, colIndex) => (
              <Col
                key={colIndex}
                xs={2}
                sm={2}
                md={2}
                lg={2}
                xl={2}
                xxl={2}
                className={
                  highlightedCells.some(
                    (highlightedCell) =>
                      highlightedCell.row === rowIndex &&
                      highlightedCell.col === colIndex
                  )
                    ? "highlighted"
                    : ""
                }
              
              >
                <div className="modified_row">{cell}</div>
              </Col>
            ))}
          </Row>
        ))}
      {/* </tbody> */}
    </div>

  
  );
}
 